// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getQuestionOpinometros as listQuestionOpinometroAPI,
    getQuestionOpinometro as getQuestionOpinometroAPI,
    addQuestionOpinometro as addQuestionOpinometroAPI,
    updateQuestionOpinometro as updateQuestionOpinometroAPI,
    deleteQuestionOpinometro as deleteQuestionOpinometroAPI,
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { questionOpinometroApiResponseError, questionOpinometroApiResponseSuccess } from './actions';
import { QuestionOpinometroActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getQuestionOpinometro({ payload: { id } }) {
    try {
        const response = yield call(getQuestionOpinometroAPI, id );
        const questionOpinometroItem = response.data.data;
        yield put(questionOpinometroApiResponseSuccess(QuestionOpinometroActionTypes.GET_QUESTION_OPINOMETRO, questionOpinometroItem));
    } catch (error) {
        yield put(questionOpinometroApiResponseError(QuestionOpinometroActionTypes.GET_QUESTION_OPINOMETRO, error));
    }
}

function* addQuestionOpinometro({payload:questionOpinometro}){
    try{
        const response = yield call(addQuestionOpinometroAPI,{...questionOpinometro})
        const questionOpinometroItem = response.data
        yield put(questionOpinometroApiResponseSuccess(QuestionOpinometroActionTypes.ADD_QUESTION_OPINOMETRO,questionOpinometroItem))
    } catch(error){
        yield put(questionOpinometroApiResponseError(QuestionOpinometroActionTypes.ADD_QUESTION_OPINOMETRO,error))
    }
}

function* updateQuestionOpinometro({payload:questionOpinometro}){
    try{
        const response = yield call(updateQuestionOpinometroAPI,{...questionOpinometro})
        const questionOpinometroItem = response.data.data
        yield put(questionOpinometroApiResponseSuccess(QuestionOpinometroActionTypes.UPDATE_QUESTION_OPINOMETRO,questionOpinometroItem))
    }catch(error){
        yield put(questionOpinometroApiResponseError(QuestionOpinometroActionTypes.UPDATE_QUESTION_OPINOMETRO,error))
    }
}
function* deleteQuestionOpinometro({payload:{id}}){
    try{
        const response = yield call(deleteQuestionOpinometroAPI,id)
        const questionOpinometroItem = response.data.id
        yield put(questionOpinometroApiResponseSuccess(QuestionOpinometroActionTypes.DELETE_QUESTION_OPINOMETRO,questionOpinometroItem))
    }catch(error){
        yield put(questionOpinometroApiResponseError(QuestionOpinometroActionTypes.DELETE_QUESTION_OPINOMETRO,error))
    }
}

/**
 * List contactos
 */
function* listQuestionOpinometro({payload:params}) {
    try {
        const response = yield call(listQuestionOpinometroAPI, { ...params });
        const listaQuestionOpinometro = response.data.data;
        yield put(questionOpinometroApiResponseSuccess(QuestionOpinometroActionTypes.LIST_QUESTION_OPINOMETROS, listaQuestionOpinometro));
    } catch (error) {
        yield put(questionOpinometroApiResponseError(QuestionOpinometroActionTypes.LIST_QUESTION_OPINOMETROS, error));
    }
}


export function* watchGetQuestionOpinometro(): any {
    yield takeEvery(QuestionOpinometroActionTypes.GET_QUESTION_OPINOMETRO, getQuestionOpinometro);
}

export function* watchListQuestionOpinometro(): any {
    yield takeEvery(QuestionOpinometroActionTypes.LIST_QUESTION_OPINOMETROS, listQuestionOpinometro);
}

export function* watchAddQuestionOpinometro():any{
    yield takeEvery(QuestionOpinometroActionTypes.ADD_QUESTION_OPINOMETRO,addQuestionOpinometro)
}
export function* watchUpdateQuestionOpinometro():any{
    yield takeEvery(QuestionOpinometroActionTypes.UPDATE_QUESTION_OPINOMETRO,updateQuestionOpinometro)
}
export function* watchDeleteQuestionOpinometro():any{
    yield takeEvery(QuestionOpinometroActionTypes.DELETE_QUESTION_OPINOMETRO,deleteQuestionOpinometro)
}


function* questionOpinometroSaga(): any {
    yield all([
        fork(watchGetQuestionOpinometro),
        fork(watchListQuestionOpinometro),
        fork(watchAddQuestionOpinometro),
        fork(watchUpdateQuestionOpinometro),
        fork(watchDeleteQuestionOpinometro),
    ]);
}

export default questionOpinometroSaga;
